import { AttentionTypes, FeederStatus } from '../../Definitions/valueTypes';
import { Animals, TestData as AnimalData } from './animalData'; // Adjust the import path as needed

export type Activation = {
    date: number;
    amount: number;
  };

  export type Skipped = {
    forNow?: boolean;
    standard?: number;
    startDate?: string;
    endDate?: string;
    startTime?: string;
    endTime?: string;
  };

export type Pens = {
  penId: number,
  activator?: boolean,
  lastActivated?: number,
  activationsToday?: number,
  activationsPast?: Activation[],
  feeding: boolean,
  motor: number,
  feederStatus: FeederStatus,
  skip?: Skipped
  attention: AttentionTypes 
  error?: string
} & Partial<Pick<Animals, "animalId">> 
  
export const TestData: Pens[] = [
  {
    penId: 301,
    animalId: 1236,
    activator: true,
    lastActivated: 1727083327,
    activationsToday: 36,
    activationsPast: [
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 }
    ],
    feeding: true,
    motor: 50,
    feederStatus: FeederStatus.calibration,
    skip: {
      startDate: "22/06/2022",
      endDate: "23/06/2022",
      startTime: "11:30",
      endTime: "10:00"
    },
    attention: AttentionTypes.good
  },
  {
    penId: 302,
    animalId: 2347,
    activator: true,
    lastActivated: 1727339484,
    activationsToday: 98,
    activationsPast: [
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 }
    ],
    feeding: false,
    motor: 60,
    feederStatus: FeederStatus.dosing,
    attention: AttentionTypes.good,
    skip: {
      startDate: "22/06/2022",
      endDate: "22/06/2022",
      startTime: "11:30",
      endTime: "12:30"
    }
  },
  {
    penId: 303,
    animalId: 3458,
    activator: true,
    lastActivated: 1727353932,
    activationsToday: 1,
    activationsPast: [
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 }
    ],
    feeding: true,
    motor: 56,
    feederStatus: FeederStatus.error,
    attention: AttentionTypes.alert,
    error: "Motor Error"
  },
  {
    penId: 304,
    animalId: 4569,
    activator: true,
    lastActivated: 1727355122,
    activationsToday: 56,
    activationsPast: [
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 },
      { date: 34567543, amount: 33 }
    ],
    feeding: true,
    motor: 0,
    feederStatus: FeederStatus.dosing,
    attention: AttentionTypes.warning,
    error: "Motor Error"
  },
  {
    penId: 305,
    animalId: 5670,
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 306,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 307,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.warning,
    error: "Motor Error"
  },
  {
    penId: 308,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.warning,
    error: "Motor Error"
  },
  {
    penId: 309,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 310,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.alert,
    error: "Motor Error"
  },
  {
    penId: 311,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 312,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.alert,
    error: "Motor Error"
  },
  {
    penId: 313,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 314,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 315,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 316,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 317,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 318,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 319,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 320,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.alert,
    error: "Motor Error"
  },
  {
    penId: 321,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 322,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 323,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.alert,
    error: "Motor Error"
  },
  {
    penId: 324,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.warning,
    error: "Motor Error"
  },
  {
    penId: 325,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 326,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 327,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 328,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 329,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 330,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 331,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 332,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 333,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 334,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 335,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 336,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 337,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 338,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 339,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  },
  {
    penId: 340,
    lastActivated: 0,
    activationsToday: 0,
    activationsPast: [],
    feeding: false,
    motor: 0,
    feederStatus: FeederStatus.off,
    attention: AttentionTypes.neutral
  }
]

// Function to get a section by ID
export function getPenById(penId: number) {
  // Find the section by ID
  const pen = TestData.find(pen => pen.penId === penId);
  
  // If the section is not found, return null
  if (!pen) return null;

  // Get detailed animal data
  const animalData = AnimalData.find(animal => animal.animalId === pen.animalId);

  return {
    ...pen,
    animalId: animalData ? animalData : null
  };
}